import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useGetAllUsersQuery, useRegisterUserMutation } from 'state/api';
import Loader from 'components/Loader';

const Register = () => {
  const [register, { loading }] = useRegisterUserMutation();
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [error, setError] = React.useState(null);

  const { data } = useGetAllUsersQuery();

  const formik = useFormik({
    initialValues: {
      name: '',
      email: '',
      password: '',
      contact: '',
      role: '',
      reportTo: '',
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .min(3, 'Name must be at least 3 characters')
        .required('Name is required'),
      email: Yup.string()
        .email('Invalid email address')
        .required('Email is required'),
      password: Yup.string()
        .min(7, "Password must be at least 6 characters")
        .required("Password is required"),
      contact: Yup.string()

        .min(10, 'Contact must be at least 10 characters')
        .required('Contact is required'),
      role: Yup.string().required('Role is required'),
    }),

    onSubmit: (values) => {
      const { name, email, password, contact, role, reportTo } = values;
      setIsSubmitting(true);
      register({ name, email, password, contact, role, reportTo })
        .unwrap()
        .then((res) => {
          alert('User Registered Successfully');
          // window.location.href = "/login";
        })
        .catch((err) => {
          setError(err.data.message);
        })
        .finally(() => {
          setIsSubmitting(false);
        });

      formik.resetForm();
    },
  });

  // show the loader initially and when the submit button is clicked
  if (loading || isSubmitting) {
    return <Loader />;
  }

  return (
    <div>
      <div className='flex items-center justify-center min-h-screen bg-gray-100'>
        <div className='px-8 py-6 mx-4 mt-4 text-left bg-white shadow-lg md:w-1/3 lg:w-1/3 sm:w-1/3'>
          <h3 className='text-2xl font-bold text-center'>Register</h3>
          <form onSubmit={formik.handleSubmit}>
            <div className='mt-4'>
              <div>
                <label className='mb-2 block' htmlFor='name'>
                  Name
                </label>
                <input
                  type='text'
                  name='name'
                  id='name'
                  placeholder='Tanuj Pancholi'
                  className='bg-gray-50 border border-gray-300 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 '
                  required
                  value={formik.values.name}
                  onChange={formik.handleChange}
                />
                {/* error message */}
                {formik.errors.name && formik.touched.name && (
                  <p className='text-red-500 text-xs italic'>
                    {formik.errors.name}
                  </p>
                )}
              </div>
              <div className='mt-4'>
                <label className='mb-2 block' htmlFor='email'>
                  Email
                </label>
                <input
                  type='email'
                  name='email'
                  id='email'
                  placeholder='xyz@gmail.com'
                  className='bg-gray-50 border border-gray-300 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 '
                  required
                  value={formik.values.email}
                  onChange={formik.handleChange}
                />
                {/* error message */}
                {formik.errors.email && formik.touched.email && (
                  <p className='text-red-500 text-xs italic'>
                    {formik.errors.email}
                  </p>
                )}
              </div>
              <div className='mt-4'>
                <label className='mb-2 block' htmlFor='password'>
                  Password
                </label>
                <input
                  type='password'
                  name='password'
                  id='passwrd'
                  placeholder='••••••••'
                  className='bg-gray-50 border border-gray-300 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 '
                  required
                  value={formik.values.password}
                  onChange={formik.handleChange}
                />
                {/* error message */}
                {formik.errors.password && formik.touched.password && (
                  <p className='text-red-500 text-xs italic'>
                    {formik.errors.password}
                  </p>
                )}
              </div>
              <div className='mt-4'>
                <label className='mb-2 block' htmlFor='contact'>
                  Contact
                </label>
                <input
                  type='tel'
                  name='contact'
                  id='contact'
                  placeholder='987635251'
                  className='bg-gray-50 border border-gray-300 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 '
                  required
                  value={formik.values.contact}
                  onChange={formik.handleChange}
                />
                {/* error message */}
                {formik.errors.contact && formik.touched.contact && (
                  <p className='text-red-500 text-xs italic'>
                    {formik.errors.contact}
                  </p>
                )}
              </div>
              <div className='mt-4'>
                <div className='dropdown text-center'>
                  <FormControl fullWidth>
                    <InputLabel id='role'>Role</InputLabel>
                    <Select
                      label='role'
                      labelId='role'
                      id='role'
                      name='role'
                      value={formik.values.role}
                      onChange={formik.handleChange}
                      required
                      size='medium'
                    >
                      <MenuItem value={'RTO Agent'}>RTO Agent</MenuItem>
                      <MenuItem value={'Sales Consultant'}>
                        Sales Consultant
                      </MenuItem>
                      <MenuItem value={'Sales Manager'}>Sales Manager</MenuItem>
                      <MenuItem value={'Insurance Agent'}>
                        Insurance Agent
                      </MenuItem>
                      <MenuItem value={'Workshop Staff'}>
                        Workshop Staff
                      </MenuItem>
                      <MenuItem value={'Accountant'}>Accountant</MenuItem>
                    </Select>
                  </FormControl>
                  {/* error message */}
                  {formik.errors.role && formik.touched.role && (
                    <p className='text-red-500 text-xs italic'>
                      {formik.errors.role}
                    </p>
                  )}
                </div>
              </div>
              <div className='mt-4'>
                <div className='dropdown text-center'>
                  <FormControl fullWidth>
                    <InputLabel id='role'>Reports to</InputLabel>
                    <Select
                      label='reportTo'
                      labelId='reportTo'
                      id='reportTo'
                      name='reportTo'
                      value={formik.values.reportTo}
                      onChange={formik.handleChange}
                      required
                      size='medium'
                    >
                      {data?.result?.map(
                        (d) =>
                          (d.role === 'Sales Manager' ||
                            d.role === 'Admin') && (
                            <MenuItem key={d._id} value={d._id}>
                              {d.name}
                            </MenuItem>
                          )
                      )}
                    </Select>
                  </FormControl>
                  {/* error message */}
                  {formik.errors.role && formik.touched.role && (
                    <p className='text-red-500 text-xs italic'>
                      {formik.errors.role}
                    </p>
                  )}
                </div>
              </div>

              <div className='flex'>
                <button
                  type='submit'
                  className='bg-black text-white rounded-lg px-3 py-2.5 hover:bg-gray-900 w-full border-none cursor-pointer hover:shadow-lg mt-6'
                >
                  Create Account
                </button>
                {/* error message */}
                {error && (
                  <p className='text-red-500 text-xs italic'>{error}</p>
                )}
              </div>
              {/* <div className="mt-6 text-grey-dark">
                Already have an account?
                <a className="text-blue-600 hover:underline" href="/login">
                  Log in
                </a>
              </div> */}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Register;
